import type { BadgeProps } from '@/components/ui/Badge'
import type { StudentStatus } from './types'

export const studentStatusTone: Record<StudentStatus, NonNullable<BadgeProps['tone']>> = {
  active: 'success',
  inactive: 'neutral',
  transferred: 'info',
  graduated: 'brand',
  expelled: 'danger',
}
